<template>
  <div>
    <van-nav-bar title="图表家用户协议" fixed="fixed">
      <template #left>
        <div @click="back()" class="backButton">
          <svg-icon icon-class="backButton" style="width:12px;height:20px;"></svg-icon>
        </div>
      </template>
    </van-nav-bar>


    <div style="padding-top: 46px;">
      <van-loading size="24px" vertical v-if="content === ''">加载中...</van-loading>
      <iframe :src="content" class="content" :style="conHeight"></iframe>

    </div>


  </div>
</template>

<script>
export default {
  name: "userAgreement",
  data() {
    return {
      content: '',
      conHeight:{
        height:''
      }
    }
  },
  methods: {
    getContent() {
      let query = this.$encrypt(this.$genQuery({}))
      this.$get(this.$store.state.apiUrl + '/sys/getAgreement', {qdata: query}).then(res => {
        this.content = res.data.user_agreement
      }).catch(err => {
        console.log(err)
      })
    },
    getHeight(){
      this.conHeight.height=window.innerHeight-46+'px';
    },
    back(){
      this.$router.push('/login')
    }
  },
  mounted() {
    this.getContent()
    window.addEventListener('resize', this.getHeight);
    this.getHeight()
  }
}
</script>

<style scoped>
.content {
  width: 100%;
  margin-bottom: 0;
  border: 0;
}
</style>
